/**
 * Legalbus COP REST API 1.0
 * REST API for the Legalbus COP digital signature platform
 *
 * The version of the OpenAPI document: 2.30.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Liveness { 
    url?: string;
    transactionId?: string;
    detailedStatus?: Liveness.DetailedStatusEnum;
    checkOperator?: boolean;
    completedIdentification?: boolean;
}
export namespace Liveness {
    export type DetailedStatusEnum = 'IN_PROGRESS' | 'COMPLETED' | 'ERROR' | 'FACE_MATCHING_COMPLETED' | 'FACE_MATCHING_FAILED';
    export const DetailedStatusEnum = {
        InProgress: 'IN_PROGRESS' as DetailedStatusEnum,
        Completed: 'COMPLETED' as DetailedStatusEnum,
        Error: 'ERROR' as DetailedStatusEnum,
        FaceMatchingCompleted: 'FACE_MATCHING_COMPLETED' as DetailedStatusEnum,
        FaceMatchingFailed: 'FACE_MATCHING_FAILED' as DetailedStatusEnum
    };
}


